module.exports = __webpack_public_path__ + "static/img/13.4ab8cc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/sp/13.png
// module id = 5vmm
// module chunks = 0